import { render, staticRenderFns } from "./parentCompany.vue?vue&type=template&id=3a05c0c0"
import script from "./parentCompany.vue?vue&type=script&lang=js"
export * from "./parentCompany.vue?vue&type=script&lang=js"
import style0 from "./parentCompany.vue?vue&type=style&index=0&id=3a05c0c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports